module.exports = __webpack_public_path__ + "img/SolG.b7627adb.png";